import { PageTransition } from '@/constant/transition'
import { motion } from 'framer-motion'

const dirToInit = {
  [PageTransition.FromRight]: { opacity: 0, x: 100 },
  [PageTransition.FromLeft]: { opacity: 0, x: -100 },
  [PageTransition.FromTop]: { opacity: 0, y: 100 },
  [PageTransition.FromBottom]: { opacity: 0, y: -100 },
  [PageTransition.FadeIn]: { opacity: 0 },
  [PageTransition.None]: { opacity: 1 },
}

export default function PageTransitionWrapper({
  children,
  direction = PageTransition.FadeIn,
}: {
  children: React.ReactNode
  direction?: PageTransition
}) {
  return (
    <motion.div
      style={{
        width: '100%',
      }}
      initial={dirToInit[direction]}
      animate={{ opacity: 1, x: 0, y: 0 }}
      transition={{ duration: 0.25, ease: 'easeInOut' }}
      className="page-animated-wrapper"
    >
      {children}
    </motion.div>
  )
}
